import labels from "../../utils/labels";
import KPITextLine from "../UI/kpi/KPITextLine";
import KpiCard from "./KpiCard";
import { ReactComponent as BriefcaseIcon } from "../../assets/icons/briefcase.svg";
import { useAppSelector } from "../../store/hooks";
import kpiStyles from "../../styles/UI/kpiPage.module.css";
import { KpiWorkTime } from "../../types/kpi";
import ComparisonChip from "../UI/chips/ComparisonChip";
import comparisonUtil from "../../utils/comparisonUtil";

const WorkTimeCard = ({
  kpiList,
  compareKpiList,
  compare,
}: {
  kpiList: KpiWorkTime;
  compareKpiList: KpiWorkTime;
  compare: boolean;
}) => {
  const { kpiData } = useAppSelector((state) => state.kpiCollectionSlice);

  const shiftText =
    kpiList.shiftHours > 0
      ? `${kpiList.shiftHours} ${labels.hours}`
      : `${kpiList.shiftMinutes} ${labels.minutes}`;
  const overtimeText =
    kpiList.overtimeHours > 0
      ? `${kpiList.overtimeHours} ${labels.hours}`
      : `${kpiList.overtimeMinutes} ${labels.minutes}`;
  const unplannedText =
    kpiList.unplannedHours > 0
      ? `${kpiList.unplannedHours} ${labels.hours}`
      : `${kpiList.unplannedMinutes} ${labels.minutes}`;
  const shiftScheduleText =
    kpiList.shiftScheduleHours > 0
      ? `${kpiList.shiftScheduleHours} ${labels.hours}`
      : `${kpiList.shiftScheduleMinutes} ${labels.minutes}`;

  return (
    <KpiCard
      title="Arbejdstid"
      icon={<BriefcaseIcon />}
      classes="w-[30%] max-w-[430px]"
    >
      <div className="flex flex-col gap-[50px]">
        {kpiData && (
          <div className="flex gap-spacing-xl justify-center mt-[25px]">
            <div className={kpiStyles.graphBars}>
              {kpiData!.pondooDashboard.workTime.overtimePercent > 0 && (
                <div
                  style={{
                    height: `${kpiData!.pondooDashboard.workTime.overtimePercent}%`,
                    backgroundColor: "var(--col-error-primary)",
                    border: "2px solid var(--col-error-3)",
                  }}
                ></div>
              )}
              {kpiData!.pondooDashboard.workTime.shiftPercent > 0 && (
                <div
                  className={kpiStyles.individualGraphBars}
                  style={{
                    height: `${kpiData!.pondooDashboard.workTime.shiftPercent}%`,
                    backgroundColor: "var(--col-graph-second)",
                    border: "2px solid var(--col-graph-second-2)",
                  }}
                ></div>
              )}
            </div>
            <div className={kpiStyles.graphBars}>
              {kpiData!.pondooDashboard.workTime.unplannedPercent > 0 && (
                <div
                  className={kpiStyles.individualGraphBars}
                  style={{
                    height: `${kpiData!.pondooDashboard.workTime.unplannedPercent}%`,
                    backgroundColor: "var(--col-warning-2)",
                    border: "2px solid var(--col-warning-primary)",
                  }}
                ></div>
              )}

              {kpiData!.pondooDashboard.workTime.shiftSchedulePercent > 0 && (
                <div
                  className={kpiStyles.individualGraphBars}
                  style={{
                    height: `${kpiData!.pondooDashboard.workTime.shiftSchedulePercent}%`,
                    backgroundColor: "var(--col-graph-third)",
                    border: "2px solid var(--col-graph-third-1)",
                  }}
                ></div>
              )}
            </div>
          </div>
        )}
        <div className="flex flex-col gap-spacing-xl">
          <KPITextLine
            compare={compare}
            title={labels.plan}
            value={shiftText}
            color="var(--col-graph-second)"
            borderColor="var(--col-graph-second-2)"
          />
          <KPITextLine
            compare={compare}
            title={labels.overtime}
            value={overtimeText}
            color="var(--col-error-primary)"
            borderColor="var(--col-error-3)"
          >
            {compare && (
              <ComparisonChip
                positiveIndicator="NEGATIVE"
                value={comparisonUtil.getRoundedComparison(
                  kpiList.overtimeHours,
                  compareKpiList.overtimeHours,
                )}
                id={compareKpiList.overtimeHours}
                unit="h"
              />
            )}
          </KPITextLine>
          <KPITextLine
            compare={compare}
            title={labels.unplannedTime}
            value={unplannedText}
            color="var(--col-warning-2)"
            borderColor="var(--col-warning-primary)"
          />
          <KPITextLine
            compare={compare}
            title={labels.plannedTime}
            value={shiftScheduleText}
            color="var(--col-graph-third)"
            borderColor="var(--col-graph-third-1)"
          />
        </div>
      </div>
    </KpiCard>
  );
};

export default WorkTimeCard;
